export default __webpack_public_path__ + "static/media/trust-9.2d0edd6b.png";